import { useHistory } from "react-router";
import HeaderBar from "../../../../components/header/headerBar";
import SelectFeild from "../../../../components/select/selectField";
import Input from "../../../../components/textfield/input";
import {
  CheckBox,
  CheckBox2,
  RadioField,
  Textarea,
  TextBox,
} from "../../../../components/textfield";
import { useEffect, useState } from "react";
import { Table, TableColumn } from "../../../../components/table";
import IconMdi from "@mdi/react";
import NumberFormat from "react-number-format";
import {
  mdiDelete,
  mdiChevronDownCircleOutline,
  mdiChevronUpCircleOutline,
  mdiAxisLock,
} from "@mdi/js";
import MainButton from "../../../../components/button/mainButton";
import EmptyModel from "../../../../components/modal/emptyModal";
import { SearchField } from "../../../../components/textfield";
import "../../../../assets/styles/admin/usergroup.scss";
import Counter from "../../../../components/counter/counter";
import moment from "moment";
import {
  Select,
  Form,
  Checkbox,
  Radio,
  Button,
  Modal,
  message,
  InputNumber,
  Row,
  Col,
  Space,
  DatePicker,
} from "antd";
import { Icon } from "@iconify/react";
import { parse } from "path";
import axios from "axios";
import Item from "antd/lib/list/Item";
import styled from 'styled-components'
import { useParams } from "react-router-dom";
import { numberWithCommas } from "../../../../helpers/functions";
interface ParamsType {
  id: string;
}
const PromotionCreate = () => {
  const { id } = useParams<ParamsType>();
  const { Option } = Select;
  const { confirm } = Modal;
  const history = useHistory();
  const [typepro, setTypePro] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isActive, setActive] = useState(true);
  const [state, setState] = useState<any>({
    courses: [],
    selectedCourses: [],
    _giveaway: [],
    buffet: [],
  });
  const [isTab1, setTab1] = useState(true);
  const [isTab2, setTab2] = useState(false);
  const [tabActive, setTabActive] = useState(1);
  const [promotionSelect, setPromotionSelect] = useState<string>("");
  const [promoCode, setProMoCode] = useState<string>("");
  const [promoCodes, setProMoCodes] = useState<string>("");
  const [creditPrice, setCreditPrice] = useState<string>("");
  const [promotionPrice, setPromotionPrice] = useState<string>("");
  const [disCount, setDisCount] = useState<string>("");
  const [quantity, setQuantity] = useState<string>("");
  const [period, setPeriod] = useState<string>("");
  const [promotionName, setPromotionName] = useState<string>("");
  const [promotionNames, setPromotionNames] = useState<string>("");
  const [searchKeyItem, setSearchKeyItem] = useState<string>("");

  const [creditPrices, setCreditPrices] = useState<string>("");
  const [dateStart, setDateStart] = useState<string>(moment().format());
  const [dateEnd, setDateEnd] = useState<string>(moment().format());
  const [annotation, setAnnotaTion] = useState<string>("");
  const [productCategories, setProductCategories] = useState<any>([]);
  const [selectProductCategories, setSelectProductCategories] =
    useState<string>("");
  const [selectedCoursesDaft, setSelectedCoursesDaft] = useState<any>([]);
  const [promotionRangeSelected, setPromotionRangeSelected] =
    useState<string>("");
  const [isPromotionActived, setIsPromotionActived] = useState<boolean>(false);
  const [modalType, setModalType] = useState<number>(0);
  const [freeLimitProductSubCategories, setFreeLimitProductSubCategories] =
    useState<any>([]);
  const [listTreatments, setlistTreatments] = useState<any>([]);
  const [selectTreatments, setSelectTreatments] = useState<any>([]);
  const [selectTreatmentsDaft, setSelectTreatmentsDaft] = useState<any>([]);

  const [usage_with_price, setUsage_with_price] = useState<any>({
    normal: false,
    promotion: false,
    buffet: false,
  });

  const promotiontype = [
    { value: "membership", name: "MEMBERSHIP" },
    { value: "normal_limit", name: "วงเงินปกติ (Fix % รายการ)" },
    { value: "buffet_special", name: "Buffet Special" },
    { value: "buffet_specific_treatment", name: "Buffet Specific Treaement" },
    { value: "package", name: "จัดแพคเกจ/Package" },
  ];

  const _buffet = [
    {
      title: "",
    },
    {
      title: "Code",
    },
    {
      title: "List",
    },
    {
      title: "Price/Unit",
      align: "center",
    },
    {
      title: "",
      align: "center",
    },
  ];

  const giveaway = [
    {
      title: "",
    },
    {
      title: "Code",
    },
    {
      title: "List",
    },
    {
      title: "No./Course",
    },
    {
      title: "Quantity",
      align: "center",
    },
    {
      title: "Unit",
      align: "center",
    },
    {
      title: "Price/Unit",
      align: "center",
    },
    {
      title: "Discount",
      align: "center",
    },
    {
      title: "PriceTotal",
      align: "center",
    },
    {
      title: "",
      align: "center",
    },
  ];


  const toggleClass = (item: any, index: number) => {
    // console.log(index)
    // setActive(!isActive);

    console.log("item => ", item);
    console.log("index => ", index);

    // item.isExpanded = !item.isExpanded;

    const courses: any = state.courses;

    for (const [ind, course] of courses.entries()) {
      console.log("data =>", course, ind);
      if (ind === index) {
        course.isExpanded = !course.isExpanded;
      }
    }

    setState({
      ...state,
      courses: courses,
    });
  };

  const Tabnav = (index: number) => {
    setTabActive(index);
    if (index == 1) {
      setTab2(false);
      setTab1(true);
    } else if (index == 2) {
      setTab1(false);
      setTab2(true);
    }
  };

  const getAPIs = async () => {
    setAnnotaTion("");

    setState({
      ...state,
      courses: [],
      selectedCourses: [],
    });
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        // deleteData(id);
      },
      width: "fit-content",
    });
  }

  useEffect(() => {
    getAPIs();
    getProductCategory();
    setPromotionSelect("membership");
  }, []);

  useEffect(() => {
    console.log("state =>", state);
  }, [state, listTreatments]);

  const getProductCategory = () => {
    axios.get(`/product-categories`).then((res) => {
      let data = res?.data?.data.map((item: any, index: number) => {
        return { value: item._id, name: item.name };
      });
      setProductCategories([{ value: "", name: "ALL" }, ...data]);
      setState({
        ...state,
        courses: res?.data?.data,
      });
    });
  };

  const onChange1 = (value: any) => {
    console.log("change =>", value);
    setPromotionSelect(value);

    if (value !== "membership" && value !== "normal_limit") {
      setPromotionPrice(creditPrice);
    }
  };
  const OnChangeDisCount = (value: any, index: number) => {
    selectTreatments[promotionSelect][index].discount = (
      Math.round(value * 100) / 100
    ).toFixed(2);
    setSelectTreatments({ ...selectTreatments });
  };
  const counterCheng = (val: any, index: number) => {
    selectTreatments[promotionSelect][index].quantity = val;
    setSelectTreatments({ ...selectTreatments });
  };

  useEffect(() => {
    console.log("promotionSelect change....", promotionSelect);
  }, [promotionSelect, selectTreatments, listTreatments]);

  useEffect(() => {
    getPromotionCode();
  }, []);
  const calculatePercen = () => {
    if (!parseFloat(creditPrice)) return 0;

    const rDiscount =
      ((parseFloat(creditPrice) - parseFloat(promotionPrice)) * 100) /
      parseFloat(creditPrice) || 0;
    // return rDiscount >= 0 && rDiscount <= 100 ? rDiscount : 0;
    return rDiscount;
  };
  const onSelect = (event: any) => {
    setSelectProductCategories(event);
    console.log("event=>>", event);
  };

  const showDeleteConfirmSelectedCourses = (id: any, name: any) => {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        let selectedCourses = state.selectedCourses;
        selectedCourses.splice(id, 1);
        setState({
          ...state,
          selectedCourses,
        });
      },
      width: "fit-content",
    });
  };

  const showDeleteConfirmTreatment = (id: any, name: any) => {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        selectTreatments[promotionSelect].splice(id, 1);
        setSelectTreatments({ ...selectTreatments });
      },
      width: "fit-content",
    });
  };

  useEffect(() => {
    getProductsub();
    if (id) getDetail()
  }, []);
  useEffect(() => {
    console.log("Update data... !" + selectTreatments.length);
  }, [selectTreatments]);


  const getDetail = () => {
    axios.get(`/promotions/${id}`).then((res) => {
      const data = res?.data;
      console.log("data =>", data);
      setSelectProductCategories(data?.productCategory?._id)
      setProMoCode(data?.code)
      setPromotionName(data?.name)
      setPromotionSelect(data?.promotionType)
      setPromotionPrice(data?.promotionPrice)
      setCreditPrice(data?.creditPrice)
      setUsage_with_price(data?.usage_with_price)
      setIsPromotionActived(data?.isPromotionActived)
      setPromotionRangeSelected(data?.promotionRangeSelected);
      let startDate = moment(data?.startDate).format('YYYY-MM-DD');
      let endDate = moment(data?.endDate).format('YYYY-MM-DD');
      console.log(startDate)
      setDateStart(startDate);
      setDateEnd(endDate);
      let newDraft = []
      newDraft[data?.promotionType] = data?.treatments.map((item: any, index: number) => ({
        name: item.treatment.name,
        code: item.treatment.code,
        price: {
          normal: {
            coursePriceLocal: item.price
          }
        }
      }));
      setSelectTreatments(newDraft)
    });
  }

  const getProductsub = () => {
    axios
      .get(`/product-sub-categories/all?search=${selectProductCategories}`)
      .then((res: any) => {
        let data = res?.data?.data;
        data = data.map((item: any) => {
          return {
            ...item,
            isExpanded: false,
            checked: false,
          };
        });

        setState({
          ...state,
          courses: data,
        });
      });
  };
  const handleSelectItem = (id: number) => {
    setIsOpen(true);
    setModalType(id);
    setState({
      ...state,
      courses: [],
    });
    axios
      .get(`/product-sub-categories/all?search=${selectProductCategories}`)
      .then((res: any) => {
        setState({
          ...state,
          courses: res?.data?.data,
        });
      });
  };

  useEffect(() => {
    axios
      .get(`/product-sub-categories/all?search=${selectProductCategories}`)
      .then((res: any) => {
        console.log(res);
        var courses: any = [];
        var { data } = res?.data;
        if (data.length > 0) {
          courses = data.map((i: any, k: number) => {
            let courses = axios
              .get(`/treatments?productCategorySub=${i?._id}`)
              .then((_res: any) => {
                listTreatments[i?.code] =
                  promotionSelect === "buffet_special" ||
                    promotionSelect === "buffet_specific_treatment"
                    ? _res?.data?.data.filter(
                      (item: any) =>
                        item?.price?.special?.coursePriceLocal !== undefined
                    )
                    : _res?.data?.data;
                setlistTreatments(listTreatments);
                return _res?.data?.data;
              });
            return { ...i, data: courses };
          });
          setState({
            ...state,
            courses: courses,
          });
        }
      });
  }, [selectProductCategories]);
  useEffect(() => {
    let courses = state.courses.map((i: any, k: number) => {
      let courses = axios
        .get(`/treatments?productCategorySub=${i?._id}`)
        .then((_res: any) => {
          listTreatments[i?.code] =
            promotionSelect === "buffet_special" ||
              promotionSelect === "buffet_specific_treatment"
              ? _res?.data?.data.filter(
                (item: any) =>
                  item?.price?.special?.coursePriceLocal !== undefined
              )
              : _res?.data?.data;
          setlistTreatments(listTreatments);
          return _res?.data?.data;
        });
      return { ...i, data: courses };
    });
    setState({
      ...state,
      courses: courses,
    });
  }, [promotionSelect]);

  function onClose() {
    setIsOpen(false);
    setIsOpen1(false);
  }
  const handleSelectTreatment = () => {
    setIsOpen1(true);
    let selectTreatmentsDaft = selectTreatments[promotionSelect] || [];
    setSelectTreatmentsDaft(selectTreatmentsDaft);
  };

  const searchItem = () => {
    if (searchKeyItem.length >= 1) {
      let calculateData = [];
      let baseData = state.courses;
      for (let i = 0; i < baseData.length; i++) {
        if (
          baseData[i]["name"].substr(0, searchKeyItem).toUpperCase() ==
          searchKeyItem.toUpperCase()
        ) {
          calculateData.push(baseData[i]);
        } else if (
          baseData[i]["name"]
            .toUpperCase()
            .indexOf(searchKeyItem.toUpperCase()) > -1
        ) {
          calculateData.push(baseData[i]);
        }
      }
      return calculateData;
    } else {
      return state.courses;
    }
  };

  const checkBoxTreatmentDaft = (item: any, code: string, indexs: number) => {
    let selectTreatmentsDafts = selectTreatmentsDaft;

    let index = selectTreatmentsDafts.findIndex(
      (i: any) => i.value === item._id
    );
    if (index === -1) {
      selectTreatmentsDafts.push({
        ...item,
        value: item._id,
        name: item.name,
        quantity: 0,
        discount: 0,
      });
    } else {
      selectTreatmentsDafts.splice(index, 1);
    }
    setSelectTreatmentsDaft(selectTreatmentsDafts);
    setState({ ...state });
  };
  const checkedTreatment = (item: any) => {
    let index = selectTreatmentsDaft.findIndex(
      (i: any) => i.value === item._id
    );
    return (index > -1) ? true : false;
  }
  const checkedTreatmentAll = (code: any) => {
    const data = listTreatments[code] || [];
    const max = data.length;
    const min = data.filter((item: any) => {
      let index = selectTreatmentsDaft.findIndex(
        (i: any) => i.value === item._id
      );
      return index > -1 ? true : false
    }).length
    return min === max && max !== 0 ? true : false;
  }
  const checkAllBoxTreatmentDaft = (data: any, code: string, index: number) => {
    for (let i = 0; i < data.length; i++) {
      checkBoxTreatmentDaft(data[i], code, i);
    }
    let courses: any = state.courses;
    for (const [ind, course] of courses.entries()) {
      if (ind === index) {
        course.checked = !course.checked;
      }
    }
    setState({
      ...state,
      courses: courses,
    });
  };
  const selectAllItemDaft2 = () => {
    let courses = state.courses;
    for (let i = 0; i < state.courses.length; i++) {
      checkAllBoxTreatmentDaft(
        listTreatments[courses[i].code],
        courses[i].code,
        i
      );
    }
    setState({
      ...state,
      courses: courses,
    });
  };
  const handleSave = () => {
    // const newPromotionPrice =
    //   promotionSelect === "membership" || promotionSelect === "normal_limit"
    //     ? promotionPrice
    //     : creditPrice;

    const body = {
      isPromotionActived,
      code: promoCode,
      codes: promoCodes,
      productCategory: selectProductCategories,
      promotionType: promotionSelect,
      promotionRangeSelected: promotionRangeSelected,
      name: promotionName,
      promotionName: promotionNames,
      promotionPrice: promotionPrice,
      promotionPrices: creditPrices,
      creditPrice: creditPrice,
      creditPrices: creditPrices,
      discount: calculatePercen(),
      treatments: JSON.stringify(selectTreatments[promotionSelect]),
      membershipProductSubCategories: JSON.stringify(
        selectTreatments[promotionSelect]
      ),
      membershipFreeLimitProductSubCategories: JSON.stringify(
        freeLimitProductSubCategories
      ),
      startDate: dateStart,
      endDate: dateEnd,
      usage_with_price,
      remark: annotation,
      quantity: quantity || 0,
      validityPeriod: period,
    };

    console.log("body =>", body);

    axios
      .post(`/promotions`, body)
      .then((res: any) => {
        history.push(`/setting/service/promotion`);
      })
      .catch((error: any) => {
        const { data } = error.response;
        for (let i in data?.error.errors) {
          message.error(data?.error.errors[i].msg);
        }
      });
  };
  const getPromotionCode = () => {
    axios.get(`/promotions/get-code`).then((res: any) => {
      setProMoCode(res?.data?.code);
      setProMoCodes(res?.data?.code);
    });
  };
  const ChangRender = styled.div``
  return (
    <>
      {
        (id) ?
          <HeaderBar title="PROMOTION / EDIT" btnBack={true} />
          :
          <HeaderBar title="PROMOTION / CREATE" btnBack={true} />
      }
      <div style={{ padding: "10px 40px" }}>
        <EmptyModel show={isOpen1} onClose={onClose} width="80%" setStyle={{ height: 'auto' }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <h4>เลือกรายการหัตถการ/Select Treatment </h4>

            <div className="row justify-center  mt-20">
              <SearchField
                placeholder="Search for Treatment Name"
                color="#fff"
                onChange={(e: any) => setSearchKeyItem(e.target.value)}
              />
            </div>
            <div
              className="row justify-start mt-20"
              style={{ color: "#5BAEA9" }}
            >
              <h6
                style={{
                  cursor: "pointer",
                  color: "rgb(91, 174, 169)",
                }}
                onClick={() => selectAllItemDaft2()}
              >
                เลือกทั้งหมด/Select All
              </h6>
            </div>
            <div className="row justify-start">
              <div className="card ex3">
                <div
                  className="card-body"
                  style={{
                    overflow: "auto",
                    height: "300px",
                  }}
                >
                  {searchItem().map((item: any, index: number) => (
                    <div className="container" key={index}>
                      <div
                        className="row collapsible"
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="col-2 col-lg-1"
                          onClick={() => toggleClass(item, index)}
                        >
                          {item?.isExpanded ? (
                            <IconMdi
                              path={mdiChevronUpCircleOutline}
                              size="25"
                              color="#5BAEA9"
                            ></IconMdi>
                          ) : (
                            <IconMdi
                              path={mdiChevronDownCircleOutline}
                              size="25"
                              color="#5BAEA9"
                            ></IconMdi>
                          )}
                        </div>
                        <div className="col-2 col-lg-1">
                          <CheckBox
                            title=""
                            style={{ alignItems: "flex-start" }}
                            isChecked={checkedTreatmentAll(item.code)}
                            onChange={(e: any) => {
                              checkAllBoxTreatmentDaft(
                                listTreatments[item.code],
                                item.code,
                                index
                              );
                              toggleClass(item, index);
                            }}
                          />
                        </div>
                        <div className="col-2 col-lg-2">{item?.code}</div>
                        <div className="col-4 col-lg-8">
                          {item?.name}
                          <div
                            className={!item.isExpanded ? "content" : "null"}
                          >
                            {listTreatments[item.code]?.map(
                              (items: any, indexs: number) => (
                                <>
                                  <CheckBox
                                    className="col-6"
                                    title={`${items?.code} ${items?.name} ${promotionSelect === "buffet_special" ||
                                      promotionSelect ===
                                      "buffet_specific_treatment"
                                      ? items?.price?.special
                                        ?.coursePriceLocal
                                      : items?.price?.normal?.coursePriceLocal
                                      }`}
                                    isChecked={checkedTreatment(items)}
                                    onChange={() =>
                                      checkBoxTreatmentDaft(
                                        items,
                                        item.code,
                                        indexs
                                      )
                                    }
                                  />
                                </>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="justify-center mt-20">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก/Cancel"
                onClick={() => onClose()}
              />
              <MainButton
                className="mg-10"
                title="บันทึกข้อมูล/Submit"
                onClick={() => {
                  setIsOpen1(false);
                  if (promotionSelect === "membership") {
                    switch (tabActive) {
                      case 1:
                        selectTreatments[promotionSelect] =
                          selectTreatmentsDaft;
                        setSelectTreatments(selectTreatments);
                        break;
                      case 2:
                        selectTreatments[promotionSelect] =
                          selectTreatmentsDaft;
                        setSelectTreatments(selectTreatments);
                        setFreeLimitProductSubCategories(selectTreatmentsDaft);
                        break;
                      default:
                        selectTreatments[promotionSelect] =
                          selectTreatmentsDaft;
                        setSelectTreatments(selectTreatments);
                        break;
                    }
                  } else {
                    selectTreatments[promotionSelect] = selectTreatmentsDaft;
                    setSelectTreatments(selectTreatments);
                  }

                  setSelectTreatmentsDaft([]);
                }}
              />
            </div>
          </div>
        </EmptyModel>
        <div className="create-page">
          <div className="title-header">
            {
              (id) ?
                <h3>แก้ไขโปรโมชั่น/Edit Promotion</h3>
                :
                <h3>สร้างโปรโมชั่น/Create Promotion</h3>
            }
          </div>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <ChangRender>
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  ประเภทหัตถการ/Treatment Type
                </div>
                <Form.Item
                  name="productCategories"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    onChange={onSelect}
                    style={{ width: "100%" }}
                    defaultValue={selectProductCategories}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={(id) ? true : false}
                    showSearch
                  >
                    {productCategories.map((item: any, index: any) => (
                      <Option value={item.value} key={item.value}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </ChangRender>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <Input
                title="รหัสโปรโมชั่น/Promotion Code"
                placeholder="63120017"
                value={promoCode}
                onChange={(e) => {
                  setProMoCode(e.target.value);
                }}
                disabled={(id) ? true : false}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <Input
                title="ชื่อโปรโมชั่น/Promotion Name"
                placeholder={promotionName}
                value={promotionName}
                onChange={(e) => {
                  setPromotionName(e.target.value);
                }}
                disabled={(id) ? true : false}
              />
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <ChangRender>
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  ประเภทโปรโมชั่น/Promotion Type
                </div>
                <Form.Item
                  name="productCategories"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    onChange={onChange1}
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    defaultValue={promotionSelect}
                    showSearch
                    disabled={(id) ? true : false}
                  >
                    {promotiontype.map((item: any, index: any) => (
                      <Option value={item.value} key={item.value}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </ChangRender>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <Input
                title="วงเงิน/Credit Price"
                placeholder="0.00"
                value={creditPrice}
                onBlur={(e: any) => {
                  setCreditPrice(Number(e.target.value).toFixed(2));

                  if (
                    promotionSelect !== "membership" &&
                    promotionSelect !== "normal_limit"
                  ) {
                    setPromotionPrice(Number(e.target.value).toFixed(2));
                  }
                }}
                onChange={(e: any) => {
                  setCreditPrice(e.target.value);

                  console.log("check v1 =>", e.target.value, promotionSelect);

                  if (
                    promotionSelect !== "membership" &&
                    promotionSelect !== "normal_limit"
                  ) {
                    console.log("check v2 =>", e.target.value);
                    setPromotionPrice(e.target.value);
                  }
                }}
                disabled={(id) ? true : false}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              {promotionSelect === "buffet_specific_treatment" ||
                promotionSelect === "buffet_special" ||
                promotionSelect === "package" ? (
                <TextBox
                  title="ราคาโปรโมชั่น/Promotion Price"
                  className="p-0"
                  value={creditPrice}
                />
              ) : (
                <Input
                  title="ราคาโปรโมชั่น/Promotion Price"
                  placeholder="0.00"
                  value={promotionPrice}
                  onBlur={(e: any) => {
                    setPromotionPrice(Number(e.target.value).toFixed(2));
                  }}
                  onChange={(e: any) => {
                    setPromotionPrice(e.target.value);
                  }}
                  disabled={(id) ? true : false}
                />
              )}
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              {promotionSelect === "membership" ||
                promotionSelect === "normal_limit" ||
                promotionSelect === "buffet_special" ||
                promotionSelect === "buffet_specific_treatment" ||
                promotionSelect === "package" ? (
                <TextBox
                  title="ส่วนลด(%)/Discount(%)"
                  className="p-0"
                  value={numberWithCommas(calculatePercen(), 2)}
                />
              ) : (
                <Input
                  title="ส่วนลด(%)/Discount(%)"
                  placeholder="40"
                  value={disCount}
                  onChange={(e: any) => {
                    setDisCount(e.target.value);
                  }}
                />
              )}
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              {promotionSelect === "membership" ||
                promotionSelect === "normal_limit" ||
                promotionSelect === "buffet_special" ||
                promotionSelect === "package" ? (
                <TextBox
                  title="จำนวน/Quantity"
                  className="p-0"
                  value={disCount}
                />
              ) : (
                <Input
                  title="จำนวน/Quantity"
                  placeholder="0"
                  value={quantity}
                  onChange={(e) => {
                    console.log("check quantity value =>", e.target.value);

                    setQuantity(e.target.value);
                  }}
                />
              )}
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              {promotionSelect === "membership" ||
                promotionSelect === "normal_limit" ||
                promotionSelect === "buffet_special" ||
                promotionSelect === "package" ? (
                <TextBox
                  title="ระยะเวลาที่ใช้ได้ (วัน)/Validity Period "
                  className="p-0"
                  value={period}
                />
              ) : (
                <Input
                  title="ระยะเวลาที่ใช้ได้ (วัน)/Validity Period "
                  placeholder="0"
                  value={period}
                  onChange={(e) => {
                    setPeriod(e.target.value);
                  }}
                />
              )}
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <div
                style={{
                  color: "rgb(91, 174, 169)",
                  fontSize: "14px",
                  fontWeight: 500,
                  position: "relative",
                  display: "flex",
                  alignContent: "center",
                  alignItems: "center",
                  height: "100%",
                  justifyContent: "flex-start",
                  marginTop: "5px",
                }}
              >
                <div>ตัดการใช้งานด้วยราคา/Usage with Price</div>
              </div>
            </Col>
            <Col xs={24} sm={8} md={16} lg={15}>
              <Row justify="space-between">
                <Col xs={24} sm={4} md={8} lg={8}>
                  <CheckBox2
                    title="ราคาปกติ/Normal "
                    labelsStyle={{ fontSize: "14px" }}
                    isChecked={usage_with_price.normal}
                    onChange={(e: any) =>
                      setUsage_with_price({
                        ...usage_with_price,
                        normal: e.target.checked,
                      })
                    }
                    disabled={
                      promotionSelect === "buffet_special" ||
                        promotionSelect === "buffet_specific_treatment" ||
                        promotionSelect === "package"
                        ? true
                        : false
                    }
                  />
                </Col>
                <Col xs={24} sm={4} md={8} lg={8}>
                  <CheckBox2
                    title="ราคาโปรโมชั่น/Promotion"
                    labelsStyle={{ fontSize: "14px" }}
                    isChecked={usage_with_price.promotion}
                    onChange={(e: any) =>
                      setUsage_with_price({
                        ...usage_with_price,
                        promotion: e.target.checked,
                      })
                    }
                    disabled={
                      promotionSelect === "normal_limit" ||
                        promotionSelect === "buffet_special" ||
                        promotionSelect === "buffet_specific_treatment" ||
                        promotionSelect === "package"
                        ? true
                        : false
                    }
                  />
                </Col>
                <Col xs={24} sm={4} md={8} lg={8}>
                  <CheckBox2
                    title="ราคาบุฟเฟ่ต์/Buffet"
                    labelsStyle={{ fontSize: "14px" }}
                    isChecked={usage_with_price.buffet}
                    onChange={(e: any) =>
                      setUsage_with_price({
                        ...usage_with_price,
                        buffet: e.target.checked,
                      })
                    }
                    disabled={
                      promotionSelect === "membership" ||
                        promotionSelect === "normal_limit" ||
                        promotionSelect === "buffet_specific_treatment" ||
                        promotionSelect === "package"
                        ? true
                        : false
                    }
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          {
            (!id) &&
            <Row
              justify="space-between"
              style={{
                marginTop: "10px",
              }}
            >
              {promotionSelect === "membership" && (
                <>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <div className="title-header">
                      <h3>วงเงินแถม/Free Credit Price</h3>
                    </div>
                  </Col>
                  <Col xs={24} sm={4} md={8} lg={7}>
                    <Input
                      title="ชื่อโปรโมชั่น/Promotion Name"
                      placeholder=""
                      value={promotionNames}
                      onBlur={(e: any) => {
                        setPromotionNames(e.target.value);
                      }}
                      onChange={(e) => {
                        setPromotionNames(e.target.value);
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={4} md={8} lg={7}>
                    <Input
                      title="รหัสโปรโมชั่น/Promotion Code"
                      placeholder="63120017"
                      value={promoCodes}
                      onChange={(e) => {
                        setProMoCodes(e.target.value);
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={4} md={8} lg={7}></Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Row
                      justify="space-between"
                      style={{
                        marginTop: "10px",
                      }}
                    >
                      <Col xs={24} sm={4} md={8} lg={7}>
                        {promotionSelect === "membership" ? (
                          <Input
                            title="วงเงิน/Credit Price"
                            placeholder="0.00"
                            value={creditPrices}
                            onBlur={(e: any) => {
                              setCreditPrices(Number(e.target.value).toFixed(2));
                            }}
                            onChange={(e) => {
                              setCreditPrices(e.target.value);
                            }}
                          />
                        ) : (
                          <Input
                            title="วงเงิน/Credit Price"
                            placeholder="0.00"
                            value={creditPrices}
                            onBlur={(e: any) => {
                              setCreditPrices(Number(e.target.value).toFixed(2));
                            }}
                            onChange={(e) => {
                              setCreditPrices(e.target.value);
                            }}
                          />
                        )}
                      </Col>
                      <Col xs={24} sm={4} md={8} lg={7}>
                        <TextBox
                          title="ราคาโปรโมชั่น/Promotion Price"
                          className="p-0"
                          value={creditPrices}
                        />
                      </Col>
                      <Col xs={24} sm={4} md={8} lg={7}></Col>
                    </Row>
                  </Col>
                </>
              )}
            </Row>
          }

          {promotionSelect === "membership" || (!id) && (
            <Row
              justify="space-between"
              style={{
                marginTop: "10px",
              }}
            >
              <Col xs={24} sm={4} md={8} lg={7}>
                <div
                  style={{
                    color: "rgb(91, 174, 169)",
                    fontSize: "14px",
                    fontWeight: 500,
                    position: "relative",
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                    height: "100%",
                    justifyContent: "flex-start",
                    marginTop: "5px",
                  }}
                >
                  <div>ตัดการใช้งานด้วยราคา/Usage with Price</div>
                </div>
              </Col>
              <Col xs={24} sm={8} md={16} lg={15}>
                <Row justify="space-between">
                  <Col xs={24} sm={4} md={8} lg={8}>
                    <CheckBox2
                      title="ราคาปกติ/Normal "
                      labelsStyle={{ fontSize: "14px" }}
                      onChange={(e: any) =>
                        setUsage_with_price({
                          ...usage_with_price,
                          normal: e.target.checked,
                        })
                      }
                    />
                  </Col>
                  <Col xs={24} sm={4} md={8} lg={8}>
                    <CheckBox2
                      title="ราคาโปรโมชั่น/Promotion"
                      labelsStyle={{ fontSize: "14px" }}
                      onChange={(e: any) =>
                        setUsage_with_price({
                          ...usage_with_price,
                          promotion: e.target.checked,
                        })
                      }
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={4} md={8} lg={8}>
                    <CheckBox2
                      title="ราคาบุฟเฟ่ต์/Buffet"
                      labelsStyle={{ fontSize: "14px" }}
                      onChange={(e: any) =>
                        setUsage_with_price({
                          ...usage_with_price,
                          buffet: e.target.checked,
                        })
                      }
                      disabled={true}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          {promotionSelect === "membership" ||
            promotionSelect === "normal_limit" ||
            promotionSelect === "buffet_special" ||
            promotionSelect === "buffet_specific_treatment" ||
            promotionSelect === "package" ? (
            <Row
              justify="space-between"
              style={{
                marginTop: "10px",
              }}
            >
              <Col xs={24} sm={4} md={8} lg={7}>
                <ChangRender>
                  <div className="heading">
                    <p>วันที่เริ่ม/Start Date</p>
                  </div>
                  <Form.Item
                    name="startDate"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="mm/dd/yyyy"
                      format="DD-MM-YYYY"
                      style={{
                        height: "auto",
                        width: "100%",
                        border: "none",
                        borderRadius: "0px",
                        borderBottom: "2px solid #d9d9d9",
                      }}
                      onChange={(e: any) => {
                        setDateStart(e.format());
                      }}
                      defaultValue={moment(dateStart) || moment()}
                    />
                  </Form.Item>
                </ChangRender>
              </Col>
              <Col xs={24} sm={4} md={8} lg={7}>
                <ChangRender>
                  <div className="heading">
                    <p>วันหมดอายุ/End Date</p>
                  </div>
                  <Form.Item
                    name="startDate"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="mm/dd/yyyy"
                      format="DD-MM-YYYY"
                      style={{
                        height: "auto",
                        width: "100%",
                        border: "none",
                        borderRadius: "0px",
                        borderBottom: "2px solid #d9d9d9",
                      }}
                      onChange={(e: any) => {
                        setDateEnd(e.format());
                      }}
                      defaultValue={moment(dateEnd) || moment()}
                    />
                  </Form.Item>
                </ChangRender>
              </Col>
              <Col xs={24} sm={4} md={8} lg={7}></Col>
            </Row>
          ) : (
            ""
          )}
          <Row
            justify="space-between"
            style={{
              marginTop: "20px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={14}>
              <Textarea
                title="หมายเหตุ/Remark"
                value={annotation}
                onChange={(e) => {
                  setAnnotaTion(e.target.value);
                }}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <Row>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <CheckBox
                    title="Active"
                    style={{ height: "auto" }}
                    labelsStyle={{ fontSize: "14px", margin: "0 5px" }}
                    isChecked={isPromotionActived}
                    onChange={(e: any) =>
                      setIsPromotionActived(e.target.checked)
                    }
                  />
                </Col>
                <Col xs={24} sm={12} md={12} lg={16}>
                  <RadioField
                    title="โปรเดือน/Month"
                    name="flexRadioDefault"
                    id="1"
                    onClick={() => setPromotionRangeSelected("month")}
                    isChecked={promotionRangeSelected === "month"}
                  />
                  <RadioField
                    title="โปรไตรมาส/Quarter"
                    name="flexRadioDefault"
                    id="2"
                    onClick={() => setPromotionRangeSelected("quarter")}
                    isChecked={promotionRangeSelected === "quarter"}
                  />
                  <RadioField
                    title="ทั้งหมด/All"
                    name="flexRadioDefault"
                    id="3"
                    onClick={() => setPromotionRangeSelected("all")}
                    isChecked={promotionRangeSelected === "all"}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div style={{ marginTop: "50px" }}>
          <div className="create-page">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {promotionSelect === "normal_limit" ||
                promotionSelect === "buffet_special" ||
                promotionSelect === "buffet_specific_treatment" ||
                promotionSelect === "package" ? (
                <h3>รายการสำหรับโปรโมชั่นนี้/Items For This Promotion.</h3>
              ) : (
                ""
              )}
              <div style={{ display: "flex", flexDirection: "column" }}>
                {promotionSelect === "normal_limit" ||
                  promotionSelect === "buffet_special" ||
                  promotionSelect === "buffet_specific_treatment" ||
                  promotionSelect === "package" ? (
                  <MainButton
                    title="Select Item"
                    onClick={() => handleSelectTreatment()}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            {promotionSelect === "normal_limit" ||
              promotionSelect === "buffet_special" ||
              promotionSelect === "buffet_specific_treatment" ? (
              <div style={{ marginTop: "20px" }}>
                <Table header={_buffet}>
                  {selectTreatments[promotionSelect]?.map(
                    (item: any, index: number) => (
                      <tr
                        key={index}
                        // onClick={() => history.push(`/ usedcourse / ${ item.SO}`)}
                        style={{ cursor: "pointer" }}
                      >
                        <TableColumn width="3%" align="center">
                          {index + 1}
                        </TableColumn>
                        <TableColumn width="10%">{item?.code}</TableColumn>
                        <TableColumn width="25%">{item?.name}</TableColumn>
                        <TableColumn width="5%">
                          <NumberFormat
                            value={Number(
                              promotionSelect === "buffet_special" ||
                                promotionSelect === "buffet_specific_treatment"
                                ? item?.price?.special?.coursePriceLocal
                                : item?.price?.normal?.coursePriceLocal
                            ).toFixed(2)}
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                        </TableColumn>
                        <TableColumn
                          width="3%"
                          align="center"
                          onClick={() =>
                            showDeleteConfirmTreatment(index, item?.name)
                          }
                        >
                          <IconMdi path={mdiDelete} size="20" color="#FF6760" />
                        </TableColumn>
                      </tr>
                    )
                  )}
                </Table>
              </div>
            ) : (
              ""
            )}
            {promotionSelect === "package" && (
              <div style={{ marginTop: "20px" }}>
                <Table header={giveaway}>
                  {selectTreatments[promotionSelect]?.map(
                    (item: any, index: number) => (
                      <tr key={index} style={{ cursor: "pointer" }}>
                        <TableColumn width="3%" align="center">
                          {index + 1}
                        </TableColumn>
                        <TableColumn width="5%">{item?.code}</TableColumn>
                        <TableColumn width="25%">{item?.name}</TableColumn>
                        <TableColumn width="3%" align="center">
                          {item?.number}
                        </TableColumn>
                        <TableColumn width="5%" align="center">
                          <Counter
                            defaultValue={item?.quantity}
                            length={1}
                            changeValue={(e: any) => counterCheng(e, index)}
                          />
                        </TableColumn>
                        <TableColumn width="3%" align="center">
                          ครั้ง
                        </TableColumn>
                        <TableColumn width="3%">
                          <NumberFormat
                            value={Number(
                              item?.price?.normal?.coursePriceLocal
                            ).toFixed(2)}
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                        </TableColumn>
                        <TableColumn width="3%" align="center">
                          <InputNumber
                            value={item?.discount}
                            step="1"
                            onChange={(e: any) => {
                              OnChangeDisCount(e, index);
                            }}
                            stringMode
                            style={{
                              boxShadow: "initial",
                              borderColor: "#ced4da",
                            }}
                            type="number"
                            width={150}
                          />
                        </TableColumn>
                        <TableColumn width="3%">
                          <NumberFormat
                            value={Number(
                              item?.price?.normal?.coursePriceLocal *
                              parseFloat(item?.quantity)
                            ).toFixed(2)}
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                        </TableColumn>
                        <TableColumn
                          width="3%"
                          align="center"
                          onClick={() =>
                            showDeleteConfirmTreatment(index, item?.name)
                          }
                        >
                          <IconMdi path={mdiDelete} size="20" color="#FF6760" />
                        </TableColumn>
                      </tr>
                    )
                  )}
                  <tr>
                    <TableColumn align="left" colspan={8}>
                      <b>รวม</b>
                    </TableColumn>
                    <TableColumn align="center" colspan={5}>
                      <b>
                        <NumberFormat
                          value={Number(
                            selectTreatments[promotionSelect]?.reduce(
                              (totol: number, i: any) => {
                                return (
                                  totol +
                                  ((i?.price?.normal?.coursePriceLocal || 0) *
                                    i?.quantity -
                                    i?.discount)
                                );
                              },
                              0
                            ) || 0
                          ).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </b>
                    </TableColumn>
                  </tr>
                </Table>
              </div>
            )}
            {promotionSelect === "membership" && (
              <div style={{ marginTop: "20px" }}>
                <div className="row">
                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      <a
                        className={`nav-link ${tabActive === 1 && "tab-promo-active"
                          }`}
                        aria-current="page"
                        onClick={(e) => Tabnav(1)}
                        href="#"
                      >
                        รายการสำหรับ MEMBERSHIP
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${tabActive === 2 && "tab-promo-active"
                          }`}
                        aria-current="page"
                        onClick={(e) => Tabnav(2)}
                        href="#"
                      >
                        รายการสำหรับ วงเงินแถม/Free
                      </a>
                    </li>
                  </ul>
                </div>
                {isTab1 && (
                  <div style={{ marginTop: "30px" }}>
                    <div className="row">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <h5>
                          รายการสำหรับโปรโมชั่นนี้/Items For This Promotion.
                        </h5>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <MainButton
                            title="Select Item"
                            onClick={() => handleSelectTreatment()}
                          />
                        </div>
                      </div>
                      <div style={{ marginTop: "20px" }}>
                        <Table header={_buffet}>
                          {selectTreatments[promotionSelect]?.map(
                            (item: any, index: number) => (
                              <tr
                                key={index}
                                // onClick={() => history.push(`/ usedcourse / ${ item.SO }`)}
                                style={{ cursor: "pointer" }}
                              >
                                <TableColumn width="3%" align="center">
                                  {index + 1}
                                </TableColumn>
                                <TableColumn width="10%">
                                  {item?.code}
                                </TableColumn>
                                <TableColumn width="25%">
                                  {item?.name}
                                </TableColumn>
                                <TableColumn width="5%">
                                  <NumberFormat
                                    value={Number(
                                      item?.price?.normal?.coursePriceLocal
                                    ).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                  />
                                </TableColumn>
                                <TableColumn
                                  width="3%"
                                  align="center"
                                  onClick={() =>
                                    showDeleteConfirmTreatment(
                                      index,
                                      item?.name
                                    )
                                  }
                                >
                                  <IconMdi
                                    path={mdiDelete}
                                    size="20"
                                    color="#FF6760"
                                  />
                                </TableColumn>
                              </tr>
                            )
                          )}
                        </Table>
                      </div>
                    </div>
                  </div>
                )}
                {isTab2 && (
                  <div style={{ marginTop: "30px" }}>
                    <div className="row">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <h5>
                          รายการสำหรับโปรโมชั่นนี้/Items For This Promotion.
                        </h5>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <MainButton
                            title="Select Item"
                            onClick={() => handleSelectTreatment()}
                          />
                        </div>
                      </div>
                      <div style={{ marginTop: "20px" }}>
                        <Table header={_buffet}>
                          {freeLimitProductSubCategories?.map(
                            (item: any, index: number) => (
                              <tr
                                key={index}
                                // onClick={() => history.push(`/ usedcourse / ${ item.SO }`)}
                                style={{ cursor: "pointer" }}
                              >
                                <TableColumn width="3%" align="center">
                                  {index + 1}
                                </TableColumn>
                                <TableColumn width="10%">
                                  {item?.code}
                                </TableColumn>
                                <TableColumn width="25%">
                                  {item?.name}
                                </TableColumn>
                                <TableColumn width="5%">
                                  {" "}
                                  <NumberFormat
                                    value={Number(
                                      item?.price?.normal?.coursePriceLocal
                                    ).toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                  />
                                </TableColumn>
                                <TableColumn
                                  width="3%"
                                  align="center"
                                  onClick={() =>
                                    showDeleteConfirmTreatment(
                                      index,
                                      item?.name
                                    )
                                  }
                                >
                                  <IconMdi
                                    path={mdiDelete}
                                    size="20"
                                    color="#FF6760"
                                  />
                                </TableColumn>
                              </tr>
                            )
                          )}
                        </Table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            <div className="justify-center mt-20">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก/Cancel"
              />
              <MainButton
                className="mg-10"
                title="บันทึกข้อมูล/Submit"
                onClick={() => handleSave()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PromotionCreate;
